/* eslint-disable */
import axios from 'axios';
import actionLoader from './store/modules/loader/actions';
import store from './store';
import { appConst } from 'constants/appConstants';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    //'Access-Control-Allow-Origin': '*',
  },
});

api.interceptors.request.use(function (config) {
  // Não adiciona token de autorização em rotas de login
  if (
    !config.url?.includes('/login') &&
    !config.url?.includes('/login-with-token')
  ) {
    const bearerToken = localStorage.getItem('token')
      ? `Bearer ${localStorage.getItem('token')}`
      : '';

    if (bearerToken) {
      config.headers.Authorization = bearerToken;
    }
  }

  return config;
});

api.interceptors.response.use(
  function (response) {
    if (response.data?.code === 500) {
      // excessão tratada no servidor
      // Evita loop: só redireciona se não estiver já na página de erro
      if (window.location.pathname !== '/erro') {
        window.location = '/erro';
      }
      // Rejeita a Promise para que o código que chamou possa tratar o erro
      return Promise.reject(new Error('Server error: code 500'));
    }

    return response;
  },
  function (error) {
    store.dispatch(actionLoader.showLoader(false));

    if (401 === error.response?.status) {
      localStorage.removeItem(appConst.STORAGE_NAME);
      localStorage.removeItem(appConst.TOKEN_NAME);
      window.location = '/login';
    } else if (500 === error.response?.status) {
      // mostrar tela de um erro inesperado na tela
      window.location = '/erro';
    } else if (403 === error.response?.status) {
      // mostrar uma tela de voce nao tem permissao pra finalizar essa opecação
      window.location = '/acesso-restrito';
    }

    return Promise.reject(error);
  }
);

export default api;
